/*global jQuery*/
const $ = jQuery
export default () => {
  (function toggle() {
    var allPanels = $('.item').hide()

    $('.toggle').click(function() {
      if (!$(this).hasClass('open')) {
        allPanels.slideUp()
        $('.toggle').removeClass('open')
        $(this)
          .addClass('open')
          .next()
          .slideDown()
        return false
      }
    })

    // open menu if is selected
    var current = $('.current-menu-item')
    var parent = $('.current-menu-ancestor')
    if (parent) {
      $(parent)
        .parent()
        .slideDown()
    }
    if (current) {
      $(current)
        .parent()
        .slideDown()
    }
  })()
}



// WEBPACK FOOTER //
// ./src/js/_toggleSidebar.js